/**
 * 获取最大最小日期时从validProps中获取；其他属性从props中获取
 */
import React, { Fragment } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { commonUtil, statusBarUtil } from '@qnpm/q-design-utils';
import BaseCalendar from './BaseCalendar';
import FakeDayText from './FakeDayText';
import MonthContent from './MonthContent';
import MonthHeader from './MonthHeader';
import { computedInitScrollPosition, computeSelectedIndexes, computeInitNumToRender } from '../../utils/handle';
const isIOS = Platform.OS === 'ios';
export default class NativeSectionContent extends BaseCalendar {
    constructor(props) {
        super(props, 'native');
        /**
         * 渲染月份
         * @param monthDate
         * @param index
         */
        this.renderMonthView = (monthDate, index) => {
            const { floatDidMount, initialNumToRender } = this.props;
            const showPlaceholder = !!(!floatDidMount &&
                !this.initRenderIndexes[index] &&
                initialNumToRender);
            // 这里的onLayout不要删，删了在安卓上View可能会被优化掉
            return (<Fragment key={'month_container_' + monthDate.monthKey}>
                <View onLayout={() => { }}>
                    {this.renderMonthHeader(monthDate, showPlaceholder)}
                </View>
                <View onLayout={() => { }}>
                    {this.renderMonthContent(monthDate, index, showPlaceholder)}
                </View>
            </Fragment>);
        };
        /**
         * 渲染月份内容
         * @param item
         * @param rowID
         * @param showPlaceholder
         */
        this.renderMonthContent = (item, rowID, showPlaceholder) => {
            // 浮层没有弹起时，展示空白占位
            if (showPlaceholder) {
                const height = this.monthHeight[rowID];
                return <View style={{ height, width: '100%' }}/>;
            }
            const { selectedDate, showToolTipMonth, selectedSameDay, startTime, endTime, allowDates, denyDates } = this.state;
            const { showUnderMonth, dayScale, mode, dataSource, accessibilityPreName, isTouchMoving, denyWeeks } = this.props;
            const { monthKey } = item;
            const canShowToolTip = showToolTipMonth === monthKey;
            return (<MonthContent key={item.monthKey + rowID} rowID={rowID} year={item.year} month={item.month} dataSource={item.weekList} mode={mode} dataConfig={dataSource} canShowToolTip={canShowToolTip} showUnderMonth={showUnderMonth} selectedSameDay={selectedSameDay} selectedDate={selectedDate} onSelect={this.updateState} dayScale={dayScale} computedStyle={this.computedStyle} needScale={this.needScale} accessibilityPreName={accessibilityPreName} isTouchMoving={isTouchMoving} startTime={startTime} endTime={endTime} allowDates={allowDates} denyDates={denyDates} denyWeeks={denyWeeks}/>);
        };
        /**
         * 日历内容layout
         * @param event
         */
        this.onContentLayout = (event) => {
            const { onLayout } = this.props;
            // 回传滚动距离
            onLayout && onLayout(event, this.initOffset);
            // 页面加载完成后，检查限制信息
            this.showLimitMessage();
        };
        const { initialNumToRender = 2 } = props;
        const { offset, position } = this.computedSelectedPosition();
        this.initRenderIndexes = computeInitNumToRender(position, initialNumToRender);
        this.initOffset = offset;
    }
    componentDidMount() {
        super.componentDidMount();
    }
    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        const { floatDidMount, onRenderFinished } = this.props;
        const { floatDidMount: prevStatus } = prevProps;
        // 浮层加载完成后进行回调
        if (floatDidMount && prevStatus !== floatDidMount) {
            onRenderFinished && onRenderFinished();
        }
    }
    componentWillUnmount() {
        super.componentWillUnmount();
        this.initOffset = 0;
        this.initRenderIndexes = {};
    }
    render() {
        const { calendarData } = this.state;
        const { selectedPayload } = this.props;
        // 单程需要底部留白
        const paddingBottom = this.getPaddingBottom();
        return (<View style={[styles.wrapper, { paddingBottom }]} onLayout={this.onContentLayout}>
                
                {commonUtil.isValidArray(selectedPayload) ? (<FakeDayText data={selectedPayload} computedStyle={this.computedStyle}/>) : null}
                {calendarData.map(this.renderMonthView)}
            </View>);
    }
    /**
     * 通过下标获取月份头部url
     * @param index
     */
    getMonthUrlByIndex(index) {
        const realIndex = Math.floor(index / 2);
        const { monthKey } = this.state.calendarData[realIndex];
        const { monthHeaderConfig = {} } = this.props;
        const { operationConfig } = monthHeaderConfig[monthKey] || {};
        this.printLog({
            action: 'click_adr_month_fix_header',
            attributes: { url: operationConfig === null || operationConfig === void 0 ? void 0 : operationConfig.scheme, monthKey }
        });
        return operationConfig === null || operationConfig === void 0 ? void 0 : operationConfig.scheme;
    }
    /**
     * 渲染月份头部
     * @param section
     * @param showPlaceholder
     */
    renderMonthHeader(section, showPlaceholder) {
        // 浮层没有弹起时，展示空白占位
        if (showPlaceholder) {
            const { monthHeader } = this.calendarLayout;
            return (<View style={{ height: monthHeader.height, width: '100%' }}/>);
        }
        const { monthHeaderConfig = {}, onOpenURL, onOpenURLCallback, accessibilityPreName, mode } = this.props;
        const { monthKey } = section;
        return (<MonthHeader key={'header_' + section.monthKey} title={section.title} config={monthHeaderConfig[monthKey]} computedStyle={this.computedStyle} onOpenURL={onOpenURL} onOpenURLCallback={onOpenURLCallback} accessibilityPreName={accessibilityPreName} mode={mode}/>);
    }
    /**
     * 点击后自动滚动到选中日期
     * @param calendarData
     * @param sectionID
     * @param data
     */
    // eslint-disable-next-line @typescript-eslint/member-ordering
    autoScroll(calendarData, sectionID, data) {
        const { onSelectScroll } = this.props;
        // 如果没有滚动函数，则直接终止
        if (!onSelectScroll) {
            return;
        }
        const positionIndexes = computeSelectedIndexes(calendarData, sectionID, data);
        const offset = computedInitScrollPosition(positionIndexes, this.calendarLayout, false, this.scrollPosition);
        onSelectScroll(offset);
    }
    /**
     * 获取底部留白
     * @private
     */
    getPaddingBottom() {
        if (!isIOS) {
            return this.calendarLayout.dayItem.height + 10;
        }
        const { mode } = this.props;
        return mode === 'single' ? statusBarUtil.getBottomBarHeight() : 0;
    }
}
const styles = StyleSheet.create({
    wrapper: {
        flex: 1,
        backgroundColor: '#FFFFFF'
    }
});
